import React from 'react';
import PropTypes from 'prop-types';

class ScrollEvent extends React.Component {

	constructor(props) {
		super(props);
		this.handleScroll = this.handleScroll.bind(this);
  }
  
	componentDidMount() {
		this.scrollElement = window;
    const system = localStorage.getItem('systemId');
    if(system === 'geotab'){
			this.scrollElement = document.getElementById('root').parentElement;
		}
    this.scrollElement.addEventListener('scroll', this.handleScroll);
  };
  
	componentWillUnmount() {
		this.scrollElement.removeEventListener('scroll', this.handleScroll);
	};
	handleScroll(event) {
		this.props.handleScrollCallback();
  };
  
	render() {
		return false;
  }
  
}
export default ScrollEvent;
ScrollEvent.Proptypes = {
	handleScrollCallback: PropTypes.func
};